module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero16.png?aa380a49";